import React from "react";

const Container = ({ children, className }) => {
  return (
    <div
      className={`lg:w-10/12 md:w-11/12 w-full md:px-0 smpx-5 px-3 mx-auto ${className}`}
    >
      {children}
    </div>
  );
};

export default Container;
